import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahServices } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahService } from '~lookups/models';

export const typePrefix = 'sah-services';

export const sahServicesApi = createApi({
  reducerPath: 'sahServicesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahServices }),
  tagTypes: ['sah-services'],
  endpoints: (builder) => ({
    getSahServices: builder.query<SahService[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params: { sort: ['name'], ...params } }),
      providesTags: [{ type: 'sah-services', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahService[]>(payload),
    }),
  }),
});

export const { useGetSahServicesQuery } = sahServicesApi;
